<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import mapCzech from "../assets/images/map-czech.png?webp&w=1324&imagetools";
	import mapCzechLg from "../assets/images/map-cz-lg.png?webp&w=1920&imagetools";
	import mapCzechText from "../assets/images/map-cz-text.svg";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./GlobalMap.translations.json";

	const translate = getTranslate(translations);
</script>

<section>
	<div class="bg-secondary relative z-10 overflow-hidden">
		<div class="container inset-0 z-10 flex items-end lg:absolute lg:bottom-[-2.4rem]">
			<div class="relative flex items-start pt-[7rem] lg:w-[37.5rem] lg:p-[3.75rem] xl:h-[33.75rem] xl:w-[49.125rem]">
				<div class="bg-tertiary absolute inset-0 hidden opacity-80 backdrop-blur-xl lg:block"></div>
				<span class="z-10 text-[2.75rem] font-semibold leading-[1.13] lg:text-[4.625rem]"
					>{translate("localLeader")}</span
				>
			</div>
		</div>
		<div class="top-[14rem] z-20 mt-20 w-full max-xl:container lg:hidden">
			<p
				class="text-md top-[25.75rem] flex flex-col xl:absolute xl:left-[76%] xl:text-start xl:text-[1.1875rem] min-[1850px]:left-[74.5%]"
			>
				<span class="flex font-bold">
					Headquarters, R&D, Production <br class="hidden xl:inline-block" /> BRANO GROUP
				</span>Hradec nad Moravicí
			</p>
			<p class="text-md top-[4.4rem] flex flex-col xl:absolute xl:left-[31%] xl:text-end xl:text-[1.1875rem]">
				<span class="flex font-bold">Production <br class="hidden xl:inline-block" /> AUTOMATIZATION</span>Nový Bor
			</p>
			<p class="text-md top-[13.2rem] flex flex-col xl:absolute xl:left-[32.1%] xl:text-end xl:text-[1.1875rem]">
				<span class="flex font-bold">
					Production <br class="hidden xl:inline-block" /> PROF SVAR s.r.o.
				</span>Mnichovo Hradiště
			</p>
			<p class="text-md top-[5.25rem] flex flex-col xl:absolute xl:left-[47.5%] xl:text-start xl:text-[1.1875rem]">
				<span class="flex font-bold">R&D <br class="hidden xl:inline-block" /> BRANO GROUP</span>Jablonec nad Nisou
			</p>
			<p class="text-md top-[12.475rem] flex flex-col xl:absolute xl:left-[53.3%] xl:text-start xl:text-[1.1875rem]">
				<span class="flex font-bold">
					Production, Distribution center <br class="hidden xl:inline-block" /> SBU COMMERCIAL VEHICLES
					<br class="hidden xl:inline-block" /> BRANOMARKET
				</span>Jilemnice
			</p>
			<p class="text-md top-[20.5rem] flex flex-col xl:absolute xl:left-[61.99%] xl:text-start xl:text-[1.1875rem]">
				<span class="flex font-bold">Production <br class="hidden xl:inline-block" /> DELTACOL CZ</span>Litovel
			</p>
			<p class="text-md top-[29.5rem] flex flex-col xl:absolute xl:left-[52.99%] xl:text-end xl:text-[1.1875rem]">
				<span class="flex font-bold">
					Production <br class="hidden xl:inline-block" /> BRANO OTBR s.r.o. <br class="hidden xl:inline-block" />
					SBU TOOLS <br class="hidden xl:inline-block" /> SBU HEATING
				</span>Olomouc
			</p>
			<p class="text-md top-[33.8rem] flex flex-col xl:absolute xl:left-[72.7%] xl:text-start xl:text-[1.1875rem]">
				<span class="flex font-bold">Production <br class="hidden xl:inline-block" /> SBU PLASTIC</span>Zubří
			</p>
		</div>
		<StaticPicture
			image={mapCzech}
			class="absolute inset-0 top-60 -z-10 h-[40rem] w-[130%] object-cover lg:hidden"
			imgClass="h-full w-[180%] translate-x-[2rem] translate-y-[-9rem] md:translate-y-[0rem] xl:translate-x-[0rem] xl:w-full object-contain lg:object-contain"
			alt={translate("mapAlt")}
			width={1324}
			height={0}
		/>
		<StaticPicture
			image={mapCzechLg}
			class="absolute inset-0 hidden h-full lg:relative lg:top-0 lg:-mb-20 lg:block lg:w-full lg:object-contain xl:mb-0"
			imgClass="h-full w-full object-contain"
			imgOverClass="lg:mt-[6px]"
			alt={translate("mapAlt")}
			width={1920}
			height={0}
			imageOver={mapCzechText}
			imageOverFlyIn
		/>
	</div>
</section>
